module.exports = __webpack_public_path__ + "images/emoji/watch.9247fc3f142f531c3fa2.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/watch.png
// module id = g8RZ
// module chunks = 13